// src/types.ts
var dataTagSymbol = /* @__PURE__ */ Symbol("dataTagSymbol");
var dataTagErrorSymbol = /* @__PURE__ */ Symbol("dataTagErrorSymbol");
var unsetMarker = /* @__PURE__ */ Symbol("unsetMarker");
export {
  dataTagErrorSymbol,
  dataTagSymbol,
  unsetMarker
};
//# sourceMappingURL=types.js.map